import script from "./CxTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./CxTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./CxTooltip.vue?vue&type=style&index=0&id=e3a0a898&lang=less"

const __exports__ = script;

export default __exports__